// from specific to general
// at least one condition has to be true in a rule
export default {
  'default': 'EUR',
  rules: [
    {
      currency: 'DKK',
      conditions: {
        brands: [75],
        countries: ['DNK']
      }
    },
    {
      currency: 'RON',
      conditions: {
        brands: [76],
        countries: ['ROU']
      }
    },
    {
      currency: 'USD',
      conditions: {
        countries: ['CAN', 'IND']
      }
    },
    {
      currency: 'GBP',
      conditions: {
        countries: ['GBR']
      }
    },
    {
      currency: 'SEK',
      conditions: {
        countries: ['SWE']
      }

    }
  ]
};


